import React, { useEffect, useState } from "react";
import { Table, InputNumber, Select, Switch } from "antd";

const { Option } = Select;

export default function PreciosPlazos({ datosCaja, setDatosCaja, actualizar }) {
  const columns = [
    {
      title: "Plazo",
      dataIndex: "plazo",
      key: "plazo",
      render: (text) => (text === "30" ? `${text} días` : `${text} meses`),
    },
    {
      title: "Precio",
      dataIndex: "precio",
      key: "precio",
      render: (_, data, index) => (
        <RenderInputPrecioPlazos
          data={data}
          index={index}
          datosCaja={datosCaja}
          setDatosCaja={setDatosCaja}
        />
      ),
    },
  ];

  const [plazos, setPlazos] = useState([]);

  const nuevoPrecioPlazo = (value) => {
    let plazos_temp = [];
    let plazo_only = [];
    value.forEach((plazo) => {
      const existe = datosCaja.precio_plazos.filter(
        (res) => res.plazo === plazo
      );
      if (existe.length) {
        const { precio, plazo } = existe[0];
        plazos_temp.push({ plazo, precio });
      } else {
        plazos_temp.push({ plazo, precio: 0 });
      }

      plazo_only.push(plazo);
    });
    setDatosCaja({ ...datosCaja, precio_plazos: plazos_temp });
    setPlazos(plazo_only);
  };

  const checkSocios = (value) => {
    setDatosCaja({ ...datosCaja, socios: value });
  };
  const checkPublico = (value) => {
    setDatosCaja({ ...datosCaja, publico: value });
  };

  useEffect(() => {
    if (actualizar && datosCaja.precio_plazos.length > 0) {
      let plazos_temp = [];
      let plazo_only = [];
      datosCaja.precio_plazos.forEach((res) => {
        plazos_temp.push({ plazo: res.plazo, precio: res.precio });
        plazo_only.push(res.plazo);
      });
      setPlazos(plazo_only);
      setDatosCaja({ ...datosCaja, precio_plazos: plazos_temp });
    }
  }, [datosCaja.precio_plazos.length]);

  return (
    <div>
      <Select
        mode="multiple"
        name="precio_plazos"
        allowClear
        style={{ width: "100%" }}
        placeholder="Selecciona plazos"
        onChange={nuevoPrecioPlazo}
        value={plazos}
      >
        <Option value="30">30 días</Option>
        <Option value="2">2 meses</Option>
        <Option value="6">6 meses</Option>
        <Option value="8">8 meses</Option>
        <Option value="12">12 meses</Option>
        <Option value="18">18 meses</Option>
        <Option value="24">24 meses</Option>
      </Select>
      <Table
        columns={columns}
        dataSource={datosCaja.precio_plazos}
        rowKey={(e, index) => index}
        size="small"
        pagination={false}
      />
      <div className="mt-4 d-flex justify-content-around">
        <div>
          <p>Producto activo</p>
          <Switch
            name="publico"
            checkedChildren="Público"
            unCheckedChildren="Oculto"
            checked={datosCaja.publico}
            onChange={checkPublico}
          />
        </div>
        <div>
          <p>Activo solo para socios</p>
          <Switch
            name="socios"
            checkedChildren="Socios"
            unCheckedChildren="Todos"
            checked={datosCaja.socios}
            onChange={checkSocios}
          />
        </div>
      </div>
    </div>
  );
}

const RenderInputPrecioPlazos = ({ data, index, datosCaja, setDatosCaja }) => {
  const { plazo, precio } = data;

  const obtenerPrecio = (precio) => {
    const precio_plazos = [...datosCaja.precio_plazos];
    precio_plazos.splice(index, 1, { plazo, precio });

    setDatosCaja({
      ...datosCaja,
      precio_plazos,
    });
  };

  return <InputNumber min={0} onChange={obtenerPrecio} value={precio} />;
};
